export enum LocalStorageKey {
  SwenBookingEngineReservationStartDate = "swenBookingEngineReservationStartDate",
  SwenAppVersion = "swenAppVersion",
}
